var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1393 8.00019C12.1393 9.55443 10.8788 10.814 9.32456 10.814C7.77033 10.814 6.51074 9.55443 6.51074 8.00019C6.51074 6.44507 7.77033 5.18549 9.32456 5.18549C10.8788 5.18549 12.1393 6.44507 12.1393 8.00019Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.32309 14.5C12.7128 14.5 15.8133 12.0627 17.5589 8C15.8133 3.93728 12.7128 1.5 9.32309 1.5H9.32665C5.93689 1.5 2.83644 3.93728 1.09082 8C2.83644 12.0627 5.93689 14.5 9.32665 14.5H9.32309Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.0a33dbc855c889f1e0c1ab1905616607.svg";
export { ForwardRef as ReactComponent };